import { create } from 'zustand';
import type { BagProtectionForm } from '~/@types/BagProtection/form';

const INITIAL_STATE_FORM: BagProtectionForm.Form = {
  address: {
    city: '',
    complement: '',
    neighborhood: '',
    noComplement: false,
    noNumber: false,
    number: '',
    state: '',
    street: '',
    zipcode: '',
  },
  contact: { cellphone: '', email: '' },
  introduction: {
    acceptAccessionTerms: false,
    acceptGeneralConditions: false,
    document: '',
    fullName: '',
  },
  personalInfo: {
    birthDate: '',
    gender: null,
    maritalStatus: null,
  },
};

interface BagProtectionState {
  form: BagProtectionForm.Form;
  setIntroduction: (introductionForm: BagProtectionForm.Introduction) => void;
  setPersonalInfo: (personalInfoForm: BagProtectionForm.PersonalInfo) => void;
  setContact: (contactForm: BagProtectionForm.Contact) => void;
  setAddress: (addressForm: BagProtectionForm.Address) => void;
}

const updateForm = (
  state: BagProtectionState,
  field: keyof BagProtectionForm.Form,
  value: any
): BagProtectionState => {
  return {
    ...state,
    form: { ...(state.form || { ...INITIAL_STATE_FORM }), [field]: value },
  };
};

const useBagProtectionForm = create<BagProtectionState>((set) => ({
  form: {
    introduction: {} as BagProtectionForm.Introduction,
    personalInfo: {} as BagProtectionForm.PersonalInfo,
    contact: {} as BagProtectionForm.Contact,
    address: {} as BagProtectionForm.Address,
  },
  setIntroduction: (introduction) =>
    set((state) => updateForm(state, 'introduction', introduction)),
  setPersonalInfo: (personalInfo) =>
    set((state) => updateForm(state, 'personalInfo', personalInfo)),
  setContact: (contact) =>
    set((state) => updateForm(state, 'contact', contact)),
  setAddress: (address) =>
    set((state) => updateForm(state, 'address', address)),
}));

export default useBagProtectionForm;
